import st from './index.module.css';

const items = [
  {
    icon: '/images/smartTvAdvertising/icons/targeting-interests.svg',
    title: 'Ըստ հետաքրքրություններնների թիրախավորում',
    description: 'Ցանկացած հետաքրքրություններ, օր.՝ ֆուտբոլ, ֆիլմեր, ավտոմեքենաներ, նորակառույց շենքեր և այլն',
    className: 'md:left-[3%] md:top-[17%]',
  },
  {
    icon: '/images/smartTvAdvertising/icons/targeting-demographic.svg',
    title: 'Դեմոգրաֆիական թիրախավորում',
    description: 'Սեռ, տարիք, կարգավիճակ',
    className: 'md:left-[51%] md:top-[24%]',
  },
  {
    icon: '/images/smartTvAdvertising/icons/targeting-geo.svg',
    title: 'Գեոթիրախավորում',
    description: 'Երկիր, քաղաք, թաղամաս, փողոց',
    className: 'md:left-[11%] md:top-[68%]',
  },
  {
    icon: '/images/smartTvAdvertising/icons/targeting-device.svg',
    title: 'Ըստ ալիքների թիրախավորում',
    description: 'Կարող ենք ներառել կամ հեռացնել ցանկացած YouTube ալիք, կինոկայք կամ պլատֆորմ',
    className: 'md:left-[60%] md:top-[63%]',
  },
];

const Targeting = () => {
  return (
    <div className="bg-[#3d3d3d] relative overflow-hidden">
      <svg
        viewBox="0 0 1440 691"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
        className="absolute translate-y-[-50px] inset-[0] w-full h-[110%] pointer-events-none select-none"
      >
        <rect width="1440" height="691" fill="#414141" />
        <g clipPath="url(#targetingClip)">
          <circle fill="none" opacity="0.18" cx="720" cy="361" r="102.45" stroke="#9DBE90" />
          <circle fill="none" opacity="0.15" cx="720" cy="361" r="204.9" stroke="#9DBE90" />
          <circle fill="none" opacity="0.12" cx="720" cy="361" r="307.35" stroke="#9DBE90" />
          <circle fill="none" opacity="0.09" cx="720" cy="361" r="409.8" stroke="#9DBE90" />
          <circle fill="none" opacity="0.06" cx="720" cy="361" r="512.25" stroke="#9DBE90" />

          <path d="M720 31V691" stroke="#9DBE90" opacity="0.08" />
          <path d="M37 361H1403" stroke="#9DBE90" opacity="0.08" />
          <path className={st.scanVertical} d="M720 31V691" stroke="#9DBE90" strokeLinecap="round" />
          <path className={st.scanHorizontal} d="M37 361H1403" stroke="#9DBE90" strokeLinecap="round" />

          <circle
            fill="none"
            className={st.orbitRing}
            cx="720"
            cy="361"
            r="102.45"
            stroke="#9DBE90"
            strokeWidth="1.5"
            strokeDasharray="2 6"
            opacity="0.35"
          />

          <circle cx="720" cy="361" r="4.5" fill="#9DBE90" opacity="0.5" />
          <circle className={st.sparkle} style={{ animationDelay: '0s' }} cx="367.117" cy="196" r="5.6" fill="#9DBE90" opacity="0.4" />
          <circle className={st.sparkle} style={{ animationDelay: '1s' }} cx="1107.03" cy="537" r="5.6" fill="#9DBE90" opacity="0.4" />
          <circle className={st.sparkle} style={{ animationDelay: '2s' }} cx="1152.57" cy="163" r="4.5" fill="#9DBE90" opacity="0.3" />
          <circle className={st.sparkle} style={{ animationDelay: '3s' }} cx="241.9" cy="548" r="4.5" fill="#9DBE90" opacity="0.3" />
        </g>
        <defs>
          <clipPath id="targetingClip">
            <rect width="1366" height="660" transform="translate(37 31)" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <div className="container relative py-[48px]">
        <h2 className="text-center font-[500] text-[28px] md:text-[36px] text-white mb-[32px] md:mb-[24px] relative z-10">
          Թիրախավորման
          <br />
          հնարավորություններ
        </h2>
        <div className="relative flex flex-col gap-[16px] md:gap-0 md:min-h-[600px]">
          {items.map((item, i) => (
            <div
              key={i}
              className={`relative md:absolute md:w-[38%] border border-[#82877E] rounded-[16px] p-[24px] flex flex-row gap-[12px] transition-all duration-300 hover:scale-[1.08] hover:z-20 hover:border-[#9DBE90] hover:bg-white/10 hover:shadow-[0_12px_32px_rgba(0,0,0,0.4)] ${item.className}`}
            >
              <div className="w-[40px] h-[40px] rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <img src={item.icon} alt="" className="w-full h-full" />
              </div>
              <div>
                <p className="text-white opacity-[0.7] text-[14px] md:text-[16px] font-[600] mb-[8px]">{item.title}</p>
                <p className="text-white opacity-[0.6] text-[14px] md:text-[16px] font-[300] leading-[24px]">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Targeting;
